import { StandardEvents } from '@shopify/events';

/**
 * Horizon normally replaces the product media gallery after a variant change.
 * This ENZO safeguard only intervenes when the returned gallery starts with a
 * different media item than the gallery currently shown.
 */
const firstMediaId = (gallery) => gallery?.querySelector('[data-media-id]')?.dataset.mediaId || '';

document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element)) return;

  const productMain = event.target.closest("main[data-template^='product']");
  const productSection = event.target.closest('.shopify-section');
  if (!productMain || !productSection || !event.promise) return;

  event.promise
    .then(({ detail }) => {
      const sourceGallery = detail?.html?.querySelector('media-gallery');
      if (!sourceGallery) return;

      requestAnimationFrame(() => {
        const currentGallery = productSection.querySelector('media-gallery');
        const expectedMediaId = firstMediaId(sourceGallery);

        if (!currentGallery || !expectedMediaId || firstMediaId(currentGallery) === expectedMediaId) return;

        currentGallery.replaceWith(sourceGallery.cloneNode(true));
      });
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[ENZO] Synchronisation du media de variante impossible.', error);
      }
    });
});
